import { createModelSegment } from 'client/data/luckdragon/segment';

export const INSPECTLET_EXPERIMENTS = 'inspectletExperiments';

export const ExperimentsModel = createModelSegment('experiments', []);
